import { ASSISTANCE_REQUEST_STATUS, ASSISTANCE_REQUEST_STATUS_INVERSE } from '../../../config/constant';
import edit from "../../../assets/Images/image/edit.png";
import { Modal, Button, TextField } from '@mui/material';
import { useState } from 'react';
import styled from 'styled-components';
import { APIError, removeUnderscoreAndCapitalize } from '../../../core/utils';
import API from '../../../api/axios';
import { APP_URLS } from '../../../api/url';
import { toast } from 'react-toastify';

const AssistanceStatuses = Object.keys(ASSISTANCE_REQUEST_STATUS).map((key) => ({
    name: removeUnderscoreAndCapitalize(key.toLowerCase()),
    value: ASSISTANCE_REQUEST_STATUS[key],
}));

const Status = ({ currentStatus, requestId, _refetchApi }) => {
    const [openFor, setOpenFor] = useState(null);
    const [updatedStatus, _updatedStatus] = useState(currentStatus);
    const [reason, setReason] = useState("");

    const handleClose = () => {
        setOpenFor(null);
        setReason("");
    };

    const handleSave = () => {

        if (updatedStatus == null) return;

        if (updatedStatus == currentStatus) {
            setReason('');
            setOpenFor(null);
            return
        }

        const payload = { status: updatedStatus }

        if (updatedStatus == ASSISTANCE_REQUEST_STATUS.NOT_CONVERTED) {
            payload['reason'] = reason
        }

        API.patch(`${APP_URLS.LIST_ASSISTANCE_REQUESTS}/${requestId}${APP_URLS.UPDATE_ASSISTANCE_REQUESTS}`, payload)
            .then((res) => {
                if (res.data.success) {
                    toast.success("Status updated successfully", { position: toast.POSITION.TOP_RIGHT });
                    _refetchApi(Math.random())
                } else {
                    toast.error(res.data.message || "Failed to update status");
                }
            })
            .catch((err) => {
                toast.error(APIError(err));
            })
            .finally(() => {
                setReason('');
                setOpenFor(null);
            });
    };

    return (
        <>
            <span className="status-column" onClick={() => setOpenFor(requestId)}>
                {ASSISTANCE_REQUEST_STATUS_INVERSE[currentStatus]}
                <img
                    src={edit}
                    alt="Edit"
                    className="mx-2"
                    role="button"
                />
            </span>

            <Modal
                open={!!openFor}
                onClose={handleClose}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <ModalWrapper>
                    <h3 id="modal-title">Update Status</h3>

                    <div className="form-group">
                        <label htmlFor="status-select">Select Status</label>
                        <select
                            id="status-select"
                            className="status-input"
                            value={updatedStatus}
                            onChange={(e) => _updatedStatus(Number(e.target.value))}
                        >
                            {AssistanceStatuses.map((status) => (
                                <option key={status.value} value={status.value}>
                                    {status.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {updatedStatus === ASSISTANCE_REQUEST_STATUS.NOT_CONVERTED && (
                        <div className="form-group">
                            <label htmlFor="reason-textarea">Reason (max 255 chars)</label>
                            <TextField
                                id="reason-textarea"
                                className='status-reason'
                                multiline
                                rows={3}
                                value={reason}
                                onChange={(e) => setReason(e.target.value.slice(0, 255))}
                                placeholder="Enter reason here..."
                                inputProps={{ maxLength: 255 }}
                                variant="standard"
                                sx={{
                                    '& .MuiInputBase-root': {
                                        border: 'none',
                                        background: 'transparent',
                                    },
                                    '& .MuiInput-underline:before': {
                                        borderBottom: 'none',
                                    },
                                    '& .MuiInput-underline:after': {
                                        borderBottom: 'none',
                                    },
                                    '& .MuiInput-underline:hover:before': {
                                        borderBottom: 'none !important',
                                    },
                                }}
                            />
                            <small>{reason.length}/255</small>
                        </div>
                    )}

                    <div className="modal-actions">
                        <Button variant="outlined" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleSave}
                            disabled={updatedStatus === 3 && reason.trim() === ""}
                        >
                            Save
                        </Button>
                    </div>
                </ModalWrapper>
            </Modal>
        </>
    );
};

export default Status;

const ModalWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  background-color: #fff;
  padding: 24px;
  border-radius: 8px;
  outline: none;
  display: flex;
  flex-direction: column;
  gap: 20px;

  h3 {
    margin: 0;
    text-align: center;
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .status-input, .status-reason {
    padding: 8px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 6px;
    background-color: white;
  }

  small {
    color: #666;
    font-size: 12px;
    text-align: right;
  }

  .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }
`;
